_ = require 'underscore'
Auth = require 'app/scripts/db/auth'
{ dontUpsell } = require '@trello/config'
config = require '@trello/config'
{ featureFlagClient } = require '@trello/feature-flag-client'
idButlerPowerUp = require 'app/scripts/data/butler-id'
makeErrorEnum = require 'app/scripts/lib/make-error-enum'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
{ Plugin } = require 'app/scripts/models/Plugin'
PluginIO = require 'app/scripts/views/internal/plugins/plugin-io'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginHandlerContext = require 'app/scripts/views/internal/plugins/plugin-handler-context'
pluginOptions = require 'app/scripts/views/internal/plugins/plugin-options'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
processCallbacks = require 'app/scripts/views/internal/plugins/plugin-process-callbacks'
Promise = require 'bluebird'
{ track } = require '@trello/analytics'
xtend = require 'xtend'

PluginRunnerError = makeErrorEnum 'PluginRunner', [
  'NotHandled'
  'InvalidPlugin'
  'Timeout'
]

DEFAULT_TIMEOUT = 5000

eventualEnabledPlugins = {}

loadAvailablePlugins = (idBoard) ->
  # We might have several PluginRunners make requests at once (e.g. for badges)
  # and we don't want all of them to trigger duplicate requests to loading the
  # plugins from the server.
  if !eventualEnabledPlugins[idBoard]?
    eventualEnabledPlugins[idBoard] = ModelLoader.loadBoardEnabledPlugins(idBoard)

    eventualEnabledPlugins[idBoard]
    .then ->
      delete eventualEnabledPlugins[idBoard]

  eventualEnabledPlugins[idBoard]

loadPlugin = (board, pluginOrId) ->
  Promise.try ->
    if pluginOrId instanceof Plugin
      return pluginOrId

    if !_.isString(pluginOrId)
      throw PluginRunnerError.InvalidPlugin("invalid plugin specifier")

    idPlugin = pluginOrId
    if (existingPlugin = ModelCache.get('Plugin', idPlugin))?
      return existingPlugin

    if !board?
      throw PluginRunnerError.InvalidPlugin("unable to find plugin")

    loadAvailablePlugins(board.id)
    .then ->
      if (existingPlugin = ModelCache.get('Plugin', idPlugin))?
        return existingPlugin

      throw PluginRunnerError.InvalidPlugin("plugin not available to board")

extractPlugins = ({ plugins, plugin, board }) ->
  plugins =
    if plugins?
      plugins
    else if plugin?
      [plugin]
    else if board?
      board.idPluginsEnabled()
    else
      []

  Promise.map plugins, (pluginOrId) =>
    loadPlugin(board, pluginOrId)

extractCommonContext = (options) ->
  board = options?.board
  baseContext =
    version: if /^build-\d+$/.test(config.clientVersion) then config.clientVersion else 'unknown'
    member: Auth.me()
    permissions:
      board: if board?.editable() then 'write' else 'read'
  if (idOrg = board?.hasOrganization())?
    baseContext.organization = idOrg
  if (org = board?.getOrganization())?
    baseContext.permissions.organization = if org?.hasActiveMembership(Auth.me()) then 'write' else 'read'
  if board?.isEnterpriseBoard() && board.getEnterprise()
    baseContext.enterprise = board.getEnterprise().id
  if options.card?
    baseContext.permissions.card = if options.card.editable() then 'write' else 'read'
  extendedContext = ['board', 'list', 'card', 'command', 'el']
  xtend baseContext, _.pick(options, extendedContext)

extractCommandOptions = ({ options }) ->
  options

returnFirstOrError = (responses) ->
  if responses.length == 0
    throw PluginRunnerError.NotHandled("no plugin handles this command")
  _.first(responses)

validateUrls = (obj, idPlugin) ->
  _.each obj, (val, key) ->
    if _.isObject(val) || _.isArray(val)
      validateUrls(val, idPlugin)
    else if key == 'url' && !pluginValidators.isValidUrlForImage(val)
      console?.warn("Invalid URL detected in Power-Up response for: #{idPlugin}")
      throw new PluginIO.Error.NotHandled("Invalid url")

class PluginRunner
  Error: PluginRunnerError
  processCallbacks: (obj, pluginEntry, baseOptions) ->
    processCallbacks obj, (runOptions) =>
      options = xtend baseOptions, runOptions
      runAction = runOptions.options.action
      @_run [pluginEntry], extractCommonContext(options), extractCommandOptions(options)
      .then(returnFirstOrError)
      .catch PluginRunnerError.NotHandled, (err) ->
        throw PluginRunnerError.NotHandled("attempt to #{ runAction } callback on plugin #{ pluginEntry.plugin.id } failed")

  _getPluginSpecificContext: (idPlugin) ->
    switch idPlugin
      when idButlerPowerUp
        # Allow Butler to know if we are in a Desktop context
        # As Butler will have to hide upsells to conform to app store rules
        dontUpsell: !!dontUpsell
        showSuggestions: featureFlagClient.get('ecosystem.butler-suggestions', false)
      else {}

  _run: (pluginEntries, commonContext, commandOptions, timeout = DEFAULT_TIMEOUT) ->
    { command, board, card, member } = commonContext

    Promise.using PluginHandlerContext.serialize(commonContext), (serializedCommonContext) =>
      Promise.filter pluginEntries, ({ io }) ->
        io.supports(command)
      .map (pluginEntry) =>
        { plugin, io } = pluginEntry

        pluginSpecificContext = @_getPluginSpecificContext(plugin.id)
        commandOptionsWithContext = xtend commandOptions,
          context: PluginHandlerContext.extend(serializedCommonContext, pluginSpecificContext)

        io.request command, pluginOptions(commandOptionsWithContext), timeout
        .then (response) =>
          validateUrls(response, plugin.id)
          return {
            response: @processCallbacks response, pluginEntry, { board, card, member }
            idPlugin: plugin.id
          }
        .catch PluginIO.Error.NotHandled, PluginIO.Error.Timeout, ->
          null
      .filter (entry) ->
        entry?
      .map ({ response, idPlugin }) ->
        if Array.isArray(response) && _.compact(response).every(_.isObject)
          _.compact(response).map((r) ->
            xtend r, { idPlugin }
          )
        else if _.isObject(response)
          xtend response, { idPlugin }
        else
          response

  _runFromOptions: (options) ->
    plugins = extractPlugins(options)
    commonContext = extractCommonContext(options)
    commandOptions = extractCommandOptions(options)

    Promise.resolve(plugins)
    .map (plugin) ->
      plugin: plugin
      io: PluginIOCache.get(plugin)
    .then (pluginEntries) =>
      @_run(pluginEntries, commonContext, commandOptions, options.timeout)

  all: (options) ->
    @_runFromOptions(options)
    .then(_.flatten)

  one: (options) ->
    @_runFromOptions(options)
    .then(returnFirstOrError)

  getOrLoadPlugin: (board, idPlugin) ->
    loadPlugin(board, idPlugin)

module.exports = new PluginRunner()
